import { render, staticRenderFns } from "./MyTickets.vue?vue&type=template&id=d89c3caa&"
import script from "./MyTickets.vue?vue&type=script&lang=js&"
export * from "./MyTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports